module.exports = __webpack_public_path__ + "static/media/Dual_Reflect_6820.d7b5556b.jpg";